import * as React from "react";
const SvgMotorTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <circle cx={20} cy={20} r={20} fill="#FDB6B2" />
    <path fill="#D4635D" d="M24.8 26a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6" />
    <path
      fill="#D4635D"
      d="M27.32 18.8H25.4c-.72-3.24-3.84-5.4-7.08-4.68-2.4.48-4.32 2.28-4.8 4.68h-.84c-1.2 0-2.28 1.08-2.28 2.28v1.56c0 .84.72 1.56 1.56 1.56h.36c0-1.56 1.32-2.88 2.88-2.88s2.88 1.32 2.88 2.88h3.84c0-1.56 1.32-2.88 2.88-2.88s2.88 1.32 2.88 2.88h.36c.84 0 1.56-.72 1.56-1.56V21.2c0-1.32-1.08-2.4-2.28-2.4m-11.88 0c.6-2.28 3-3.48 5.16-2.88 1.32.36 2.4 1.44 2.88 2.88zm-.24 3.6c-.96 0-1.8.84-1.8 1.8s.84 1.8 1.8 1.8 1.8-.84 1.8-1.8-.84-1.8-1.8-1.8"
    />
  </svg>
);
export default SvgMotorTable;